import Auth0Service from "./auth0.service";
import LocalStorageService from "./localStorage.service";
import UserService from "./user.service";
import AddressService from "./address.service";
import ClientService from "./client.service";
import PlanService from "./plan.service";
import ContractService from "./contract.service";
import ModuleRoleService from "./module-role.service";
import UserTypeService from "./user-type.service";
import DomainService from "./domain.service";
import BlogA3FirmaDigitalService from "./blog-a3firmadigital.service";
import SessionService from "./session.service";
import MessageService from "./message.service";
import CompanyService from "./companys.services";
import ClientCompanyService from "./client-company.service";
import UpdateToken from "./update-token.service";
import NotificationResendService from "./notification-resend.service";
import NotificationSocketService from "./notification-socket.service";
import ClientsService from "./clients.service";
import CacheStorageService from "./cacheStorage.service";
import MarketNicheService from './market-niche.service'
import CatalogService from './catalog.service'
import OnboardingUserService from './onboarding-user.service'
import ChatbotService from "./chatbot.service";
import PermissionService from "./permission.service";
import axios from "axios";
import { ModalUtil } from "../components/pures";
import i18n from "../i18n";
import BranchOfficeService from "./branch-office.service";
import UsageService from "./usage.service";

const modalUtil = new ModalUtil()

axios.interceptors.request.use(function (config) {
  const localStorageService = new LocalStorageService()
  const token = localStorageService.getLocalStorageItem('token')
  const language = localStorageService.getLocalStorageItem('i18nextLng', false)
  const timezone = localStorageService.getLocalStorageItem('timezone')

  if (token) config.headers.Authorization = `Bearer ${token.idToken}`;
  config.headers['Accept-Language'] = language ? language : 'en'
  if (timezone) config.headers['X-User-Timezone'] = timezone

  return config;
}, function (error) {
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  const foundIgnoreError = () => {
    const ignoreErrors = [
      '/contract-user-passthrough',
      '/conversation-upsert'
    ]

    const aux = ignoreErrors.find((ignoreError) => { if (response?.request?.responseURL?.includes(ignoreError)) return ignoreError })
    return !!aux
  }

  const ignore = response?.request.responseURL ? foundIgnoreError() : false

  // Any status code that lie within the range of 2xx
  if (response.data.statusCode !== 200 && !ignore) {
    modalUtil.showModal('error', response.data.message, i18n.t("modal.pure.title.error"))
  }
  return response;
}, function (error) {
  const customErrors = {
    "ERR_NETWORK": "modal.pure.message.network.error",
    "DEFAULT": "modal.pure.message.error"
  }

  if (error.name === 'AbortError' || error.name === 'CanceledError') {
    return Promise.resolve()
  }

  if (error.response?.status === 401 && error.response?.data?.name === 'TokenExpiredError') {
    localStorage.clear()
    window.location.reload()
  }

  // Verificación correcta (usa hasOwnProperty o in)
  const errorKey = error.code in customErrors ? error.code : "DEFAULT"
  const messageKey = customErrors[errorKey]

  modalUtil.showModal(
    'error',
    messageKey ? i18n.t(messageKey) : error.message,
    i18n.t("modal.pure.title.error")
  )

  return Promise.reject(error);
});

export {
  Auth0Service,
  LocalStorageService,
  UserService,
  AddressService,
  ClientService,
  PlanService,
  ContractService,
  ModuleRoleService,
  UserTypeService,
  DomainService,
  BlogA3FirmaDigitalService,
  SessionService,
  MessageService,
  CompanyService,
  ClientCompanyService,
  UpdateToken,
  NotificationResendService,
  NotificationSocketService,
  ClientsService,
  CacheStorageService,
  MarketNicheService,
  CatalogService,
  OnboardingUserService,
  ChatbotService,
  BranchOfficeService,
  UsageService,
  PermissionService
};
